import React, { useEffect, useRef, useState } from 'react';

const DownloadSampleFile = ({ title = '', href = [], listHeading = [], classes = ''}) => {
	const [show, setShow] = useState(false)
	const menuRef = useRef()
	useEffect(()=>{
	document.addEventListener("mousedown",(event)=>{
	if(menuRef.current && !menuRef.current.contains(event.target)){
	setShow(false);
	}
	})
	})
	return (
		<div className="relative inline-block text-left" ref ={menuRef}>
			<div className={classes}>
				<button 
				type="button" 
				className={`inline-flex justify-center w-full border border-gray-275 text-blue-600 shadow-sm rounded-md text-base font-semibold py-2.5 px-5 focus:outline-none focus:ring-0 focus:ring-offset-0 focus:ring-offset-none`}
				id="menu-button" 
				aria-expanded="true" 
				aria-haspopup="true" 
				onClick={() => setShow((show) => !show)}
				>
					{title}
				<div className='vertical-middle pt-px'>
					<svg className="-mr-1.5 ml-1.5 h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
						<path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
					</svg>
				</div>
				</button>
			</div>
			{ show && 
			  <div className={`${classes} origin-top-right absolute right-0 z-10 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none`} role="menu" aria-orientation="vertical" aria-labelledby="menu-button" tabIndex="-1">
			  	<div className="py-1" role="none">
				{ listHeading.map((item, index) => {
					return (
					<div key={`${item}`+ index}> 
						<a 
						href={href[index]} 
						className="text-gray-700 block px-4 py-2 text-sm" 
						role="menuitem" 
						tabIndex="-1" 
						id="menu-item-1"
						onClick={()=> setShow(!show)}
						>
							{item}
						</a>
					</div>
				  )
				})}
			</div>
			</div>
		} 
		</div>
	)
};

	export default DownloadSampleFile;
